import { tabClasses, tabsClasses } from "@mui/material"

export const modalEmptyWrapper = {
  px: { xs: 2, md: 3, lg: 4 },
  pt: { xs: 2, md: 3, lg: 4 },
  pb: 2,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}

export const textTab = {
  [`& .${tabClasses.root}`]: {
    fontSize: { xs: 20, md: 24 },
    fontWeight: 400,
    p: 2,
    flexBasis: "50%",
    backgroundColor: "selectInputBackground",
  },
  [`& .${tabClasses.selected}`]: {
    backgroundColor: "white",
  },
  [`& .${tabsClasses.indicator}`]: {
    backgroundColor: "unset",
  },
}
export const textStyle = {
  fontWeight: 600,
  textAlign: "center",
}

export const tabBorderTopLeft = {
  borderTopLeftRadius: 16,
}

export const tabBorderTopRight = {
  borderTopRightRadius: 16,
}
